import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import {bindActionCreators} from 'redux';
import { setEmailOptOut } from '../../member/actions/member';
import { setLeapOptIn } from '../../../actions/reservation';
import LeapOptIn from '../components/LeapOptIn';
import { getCurrentCheckoutStep } from '../../../selectors/ui';
import Translation from "../../../../shared/Translation";

const defaultLabel = "checkout__leap_opt_in";

class LeapOptInContainer extends Component {
    render() {

        if (!this.props.currentStep || this.props.currentStep.title !== 'Registration' || !this.props.uiConfig.show_leap_opt_in) {
            return null;
        }

        const customLabel = this.props.uiConfig.leap_opt_in_text;


        const label = customLabel && customLabel !== <span></span> ? <span>{customLabel}</span> : <Translation>{defaultLabel}</Translation>;

        return (
            <LeapOptIn
                uiConfig={this.props.uiConfig}
                onChangeLeapOptIn={this.changeLeapOptIn}
                leapOptIn={this.props.leapOptIn}
                label={label}
            />
        )
    }

    changeLeapOptIn = (e) => {
        this.props.setLeapOptIn(e.target.checked) || this.props.leapOptIn;
    }
}

const mapStateToProps = state => {
    return {
        uiConfig: state.ui?.uiConfig,
        leapOptIn: state.reservation?.leapOptIn,
        currentStep: getCurrentCheckoutStep(state)
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        setLeapOptIn
    }, dispatch);
}

LeapOptInContainer.propTypes = {
}

export default connect(mapStateToProps, mapDispatchToProps)(LeapOptInContainer);
